function initQuickCardProducts() {
  document.querySelectorAll(".quick-card-product").forEach((card) => {
    if (card.dataset.quickCardInited) return;
    card.dataset.quickCardInited = "true";

    const productData = JSON.parse(card.dataset.productJson);

    const form = card.querySelector(".quick-add-form");
    const variantIdInput = form.querySelector("input[name='id']");
    const productPrice = card.querySelector(".quick-card-product__price");
    const priceEl = card.querySelector(".quick-card-product__current-price");
    const comparePriceEl = card.querySelector(
      ".quick-card-product__compare-price"
    );
    const imageEl = card.querySelector(".quick-card-product__image");

    // ===== MAIN UPDATE FUNCTION =====
    function updateVariant() {
      const selectedOptions = [];
      card.querySelectorAll(".variant-select").forEach((select) => {
        selectedOptions[parseInt(select.dataset.optionPosition) - 1] =
          select.value.replace(/ - sold out$/, "");
      });

      const colorBtn = card.querySelector(".card-product__color-option.active");
      if (colorBtn) {
        const colorValue = colorBtn.dataset.value;
        const colorOptionIndex = productData.options.indexOf("Color");
        if (colorOptionIndex > -1) {
          selectedOptions[colorOptionIndex] = colorValue;
        }
      }

      const matchedVariant = productData.variants.find((v) =>
        v.options.every((opt, i) => opt == selectedOptions[i])
      );

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;

        const noCentsFormat = window.moneyFormat.replace(
          /{{\s*amount.*?}}/,
          "{{amount_no_decimals}}"
        );

        priceEl.textContent = Shopify.formatMoney(
          matchedVariant.price,
          noCentsFormat
        );

        if (matchedVariant.compare_at_price > matchedVariant.price) {
          comparePriceEl.textContent = Shopify.formatMoney(
            matchedVariant.compare_at_price,
            noCentsFormat
          );
          productPrice.classList.add("discounted");
          comparePriceEl.style.display = "inline";
        } else {
          comparePriceEl.style.display = "none";
          productPrice.classList.remove("discounted");
        }

        if (matchedVariant.featured_image) {
          imageEl.src = matchedVariant.featured_image.src.replace(
            /(\.[^.]*)$/,
            "_1000x$1"
          );
          imageEl.alt = matchedVariant.featured_image.alt || productData.title;
        }

        updateAvailability(matchedVariant);
      }

      updateOptionAvailability(selectedOptions);
    }

    // ===== UPDATE ADD TO CART BUTTON =====
    function updateAvailability(variant) {
      const addToCartBtn = card.querySelector(".quick-add-button");

      if (variant.available) {
        addToCartBtn.innerHTML = `${window.addText} <span class="svg_wrapper-micro">${window.addIcon}</span>`;
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = window.soldOutText;
      }
    }

    // ===== UPDATE SOLD OUT LABELS IN SELECT OPTIONS =====
    function updateOptionAvailability(selectedOptions) {
      card.querySelectorAll(".variant-select").forEach((select) => {
        const optionIndex = parseInt(select.dataset.optionPosition) - 1;
        const optionName = productData.options[optionIndex]; // e.g. "Size"

        Array.from(select.options).forEach((opt) => {
          const pureValue = opt.value.replace(/ - sold out$/, "");

          // build temp selection to test this option
          const testOptions = [...selectedOptions];
          testOptions[optionIndex] = pureValue;

          const matchingVariant = productData.variants.find((v) =>
            v.options.every((val, i) => val == testOptions[i])
          );

          if (!matchingVariant || !matchingVariant.available) {
            opt.textContent = `${optionName}: ${pureValue} - sold out`;
          } else {
            opt.textContent = `${optionName}: ${pureValue}`;
          }
        });
      });

      // ===== UPDATE COLOR BUTTONS TOO =====
      const colorOptionIndex = productData.options.indexOf("Color");
      if (colorOptionIndex > -1) {
        card.querySelectorAll(".card-product__color-option").forEach((btn) => {
          const colorValue = btn.dataset.value;
          const testOptions = [...selectedOptions];
          testOptions[colorOptionIndex] = colorValue;

          const matchingVariant = productData.variants.find((v) =>
            v.options.every((val, i) => val == testOptions[i])
          );

          if (!matchingVariant || !matchingVariant.available) {
            btn.classList.add("disabled");
          } else {
            btn.classList.remove("disabled");
          }
        });
      }
    }

    // ===== EVENT LISTENERS =====
    card.querySelectorAll(".variant-select").forEach((select) => {
      select.addEventListener("change", updateVariant);
    });

    card.querySelectorAll(".card-product__color-option").forEach((btn) => {
      btn.addEventListener("click", () => {
        card
          .querySelectorAll(".card-product__color-option")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        updateVariant();
      });
    });

    // ===== INITIAL STATE =====
    updateVariant();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initQuickCardProducts();
  window.initQuickCardProducts = initQuickCardProducts;
});
